import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MessageService } from '../message.service';
import { NotifierService } from 'angular-notifier';
import { Formatters } from 'angular-slickgrid';
import { RestApiService } from '../rest-api.service';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { FormControl } from '@angular/forms';
import { CustomInputEditor } from '../custom-inputEditor';


@Component({
    selector: 'app-braio-mapping-master',
    templateUrl: './braio-mapping-master.component.html',
    styleUrls: ['./braio-mapping-master.component.css']
})
export class BraioMappingMasterComponent implements OnInit, OnDestroy {
    categorySelected: any;
    show: boolean;
    dataset: any[];
    totalData: number;
    respObject: any;
    categories = [];
    category: string;
    resolverGroup: string;
    resolverUser: string;
    // categoryArr = [];
    // ticket_status = [];
    // ststusSelected: number;
    // status_sequence: number;
    ticketStatus: string;
    // ticketTypeSeqNo: number;
    // selectSlaCalculationType: number;
    // sub_client: number;
    displayData: any;
    add = false;
    del = false;
    edit = false;
    view = false;

    isError = false;
    errorMessage: string;

    private notifier: NotifierService;
    private clientId: number;
    tickets = [];
    ticketSelected: number;
    typesla: any;
    type: string;
    nextOffset: number;
    previousOffset: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    private baseFlag: any;
    private userAuth: Subscription;
    offset: number;
    // radioChecked: number;
    dataLoaded: boolean;
    // showSearch = true;
    isLoading = false;
    // searchData: FormControl = new FormControl();
    categrySelected: any;
    categrys: any;
    ticketTyp: string;
    urlVal: string;
    // @ViewChild('scarch_content') private scarch_content;
    // private searchModalReference: NgbModalRef;
    categoryLoaded: boolean;
    ticketTypes = [];
    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
        private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            switch (item.type) {
                case 'change':
                    console.log('changed');
                    if (!this.messageService.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {

                        if (confirm('Are you sure?')) {
                            this._rest.updateBraioMapping(item).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', this.respObject.errorMessage);
                            });
                        }


                    }
                    break;
                case 'delete':
                    // console.log('deleted');
                    if (!this.messageService.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            this._rest.deleteBraioMapping({
                                id: item.id,
                                user_id: this.messageService.getUserId()
                            }).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    this.messageService.sendAfterDelete(item.id);
                                    this.totalData = this.totalData - 1;
                                    this.messageService.setTotalData(this.totalData);
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', this.respObject.errorMessage);
                            });
                        }
                    }
                    break;
            }
        });
    }

    ngOnInit() {
        // this.selectSlaCalculationType = 0;
        this.categoryLoaded = true;
        this.ticketTypes = [];
        this.dataLoaded = false;
        // this.ststusSelected = 0;
        // this.resolverGroup = 'false';
        // this.resolverUser = 'false';
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.paginationType = 'next';
        this.displayData = {
            pageName: 'Maintain Braio on Category Change',
            openModalButton: 'Mapping Braio Mapping on Category Change',
            searchModalButton: 'Search',
            tabName: 'Mapping Braio on Category Change'
        };
        const columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
            {
                id: 'type', name: 'Ticket Type', field: 'ticket_type', sortable: true, filterable: true
            },
            {
                id: 'category', name: 'Category', field: 'category', sortable: true, filterable: true
            },
            {
                id: 'parentPath', name: 'Category Details List', field: 'parentPath', sortable: true, filterable: true
            },
            {
                id: 'priority', name: 'Priority', field: 'priority', sortable: true, filterable: true
            },


            {
                id: 'url', name: 'URL', field: 'url', sortable: true, filterable: true, cssClass: 'highlight', editor: {
                    model: CustomInputEditor,
                }

            }
        ];
        this.messageService.setColumnDefinitions(columnDefinitions);
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.view = auth[0].viewFlag;
                this.add = auth[0].addFlag;
                this.edit = auth[0].editFlag;
                this.del = auth[0].deleteFlag;
                this.clientId = auth[0].clientId;
                this.baseFlag = auth[0].baseFlag;
                this.onPageLoad();
            });
        }

    }

    onPageLoad() {
        this.categoryLoaded = true;
        this.ticketTypes = [];
        //   this._rest.getSlaCalculation(this.clientId).subscribe((res1) => {
        //     this.respObject = res1;
        //     if (this.respObject.success) {
        //         this.isError = false;
        //         this.respObject.details.unshift({id: 0, sla_calculation_based_on_type: 'Select sla calculation based on type'});
        //         this.typesla = this.respObject.details;
        //         this.selectSlaCalculationType = 0;
        //     } else {
        //         this.notifier.notify('error', this.respObject.errorMessage);
        //     }
        // }, (err) => {
        //     this.notifier.notify('error', JSON.stringify(err));
        // });

        this._rest.getTicketType(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({ id: 0, name: 'Select Ticket Type' });
                this.tickets = this.respObject.details;
                this.ticketSelected = 0;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
        this.getTableData();
    }

    getTableData() {
        if (!this.messageService.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({ 'offset': this.nextOffset, 'paginationType': '' });
        }
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }

    onCategoryChange(selectedIndex) {
        this.category = this.categories[selectedIndex].name;
    }

    // onStatusChange(selectedIndex: any) {
    //     this.ticketStatus = this.ticket_status[selectedIndex].status;
    //     this.status_sequence = this.ticket_status[selectedIndex].sequence;
    // }

    openModal(content) {

        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.ticketTypes = [];
            this.isError = false;
            this.ticketSelected = 0;
            this.categorySelected = 0;
            this.urlVal = '';
            this.categoryLoaded = true;
            // this.selectSlaCalculationType = 0;
            // this.categoryArr = [];
            this.modalService.open(content, { size: 'lg' }).result.then((result) => {
            }, (reason) => {
            });


            //   this._rest.getSubClient(this.clientId).subscribe((res) => {
            //     this.respObject = res;
            //     if (this.respObject.success) {
            //          this.sub_client = this.respObject.details[0].sub_client;
            //     } else {
            //         this.isError = true;
            //         this.errorMessage = this.respObject.errorMessage;
            //     }
            // }, (err) => {
            //     this.isError = true;
            //     this.errorMessage = this.messageService.SERVER_ERROR;
            // });
        }
    }


    // searchModal() {
    //         this.categrySelected = '';
    //         this.searchModalReference = this.modalService.open(this.scarch_content);
    //         this.searchModalReference.result.then((result) => {
    //         }, (reason) => {

    //         });


    // }


    // search() {
    //     this._rest.searchAllCategorySlaMap(this.categrySelected, this.clientId).subscribe((res1) => {
    //         this.respObject = res1;
    //         this.isLoading = false;
    //         if (this.respObject.success) {
    //             this.categrys = this.respObject.details;
    //             this.messageService.setTotalData(this.categrys.length);
    //             this.messageService.setGridData(this.categrys);
    //             this.searchModalReference.close();

    //         } else {
    //             this.notifier.notify('error', this.respObject.errorMessage);
    //         }
    //     }, (err) => {
    //         this.isLoading = false;
    //         this.notifier.notify('error', this.messageService.SERVER_ERROR);
    //     });
    // }

    // onOptionChange(selectedIndex: any) {
    //   this.selectSlaCalculationType = this.typesla[selectedIndex].id;
    // }

    save() {
        const data = {
            clientId: this.clientId,
            ticketTypeId: this.ticketSelected,
            category_id: this.categorySelected,
            url: this.urlVal,
            createdBy: this.messageService.getUserId()
        };
        // if (this.sub_client === 1) {
        if (!this.messageService.isBlankField(data)) {
            console.log(JSON.stringify(data));
            this._rest.insertBraioMapping(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.isError = false;

                    const id = this.respObject.details;
                    // this.messageService.setRow({
                    //     id: id,
                    //     ticket_type: this.type,
                    //     category: this.category,
                    //     url: this.urlVal,
                    // });
                    this.nextOffset = 0;
                    this.page_no = 0;
                    this.getTableData();
                    this.totalData = this.totalData + 1;
                    this.messageService.setTotalData(this.totalData);

                    if (this.totalData <= this.pageSize * this.page_no) {
                        this.offset = id;
                        this.nextOffset = 0;
                    } else {
                        this.nextOffset = this.offset;
                    }

                    // this.nextOffset = 0;
                    // this.page_no = 0;
                    // this.getTableData();
                    this.urlVal = '';
                    this.categorySelected = 0;
                    this.ticketSelected = 0;
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
        // } else {
        //   this.isError = true;
        //    this.errorMessage = this.messageService.SUB_CLIENT_ERROR;
        // }
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded = false;
        this._rest.getallBraioMapping(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded = true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({ 'offset': this.nextOffset, 'paginationType': '' });
    }

    onTicketChange_old(selectedIndex: any) {
        this.type = this.tickets[selectedIndex].name;
        this._rest.getLastLevelCategoryByTicketType(this.clientId, this.ticketSelected).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({ id: 0, name: 'Select Category' });
                this.categories = this.respObject.details;
                this.categorySelected = 0;
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
    }
    
    onTicketChange(selectedIndex: any) {
        this.categoryLoaded = false;
        this._rest.getTicketCreateLoadingDtls(this.messageService.getUserId(), this.ticketSelected, this.clientId).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.categoryLoaded = true;
                this.ticketTypes = this.respObject.details[0].attribute;
            } else {
                this.categoryLoaded = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        });
    }

    parentSelected: any;
    onCategoryChangeDropDown(val1, val2) {
        console.log(JSON.stringify(val1) + ' -- ' + JSON.stringify(val2));
        const opt = JSON.parse(val2);
        console.log(' opt -- ' + opt);
        console.log(this.ticketTypes.length + ' -- ' + val1.id);
        if (this.ticketTypes.length === val1.id) {
            console.log('this.selectedParentCategoryId ==> ' + opt.id);
            this.parentSelected = opt.id;
            this.categorySelected = this.parentSelected;
        } else {
            this.dataLoaded = false;
            this._rest.getAttributesParentWise(this.clientId, opt.id).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    console.log(val1.id);
                    //console.log(JSON.stringify(this.ticketTypes));
                    let nextid = val1.id;
                    console.log(nextid + ' --- NEEXT CAT DROPDOWN' + JSON.stringify(this.ticketTypes[nextid]));

                    let resobj = [];
                    for (let i = 0; i < this.respObject.details.length; i++) {
                        resobj.push({ id: this.respObject.details[i].id, title: this.respObject.details[i].title });
                    }

                    resobj.unshift({
                        id: this.ticketTypes[nextid].options[0].id, title: this.ticketTypes[nextid].options[0].title
                    });

                    console.log(nextid + ' --- NEEXT CAT DROPDOWN VALUE == >> ' + JSON.stringify(resobj));
                    this.ticketTypes[val1.id].options = resobj;
                    this.dataLoaded = true;

                } else {
                    this.dataLoaded = true;
                    this.notifier.notify('error', this.messageService.SERVER_ERROR);
                }
            }, (err) => {
                this.dataLoaded = true;
                this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
        }
        this.dataLoaded = true;
    };


    ngOnDestroy(): void {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
    }


}
